import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AboutPageComponent } from './about/about-page.component';
import { PortalApiComponent } from './portal-api/portal-api.component';
import { PortalAdminApiComponent } from './portal-admin-api/portal-admin-api.component';

export const routes: Routes = [
  {
    path: 'about',
    component: AboutPageComponent,
    data: {
      caption: 'About',
    },
  },
  {
    path: 'portalapi',
    component: PortalApiComponent,
    data: {
      caption: 'Portal API',
    },
  },
  {
    path: 'portaladminapi',
    component: PortalAdminApiComponent,
    data: {
      caption: 'Portal Admin API',
      adminOnly: true,
    },
  },
  {
    path: '',
    redirectTo: 'about',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ResourceCenterRoutingModule {}
